<template>
    <v-container class="px-0" fluid>

        <v-form>
            <v-card class="pa-8 ma-3">
                <h3>{{ $t('pos.saleTab["Fjerning av Besok i kasse Metode"]') }}</h3>
                <v-row>
                    <v-col cols="2">
                        <v-radio-group v-model="radioGroup">
                            <v-radio :label="$t(`pos.saleTab['Ingen sletting']`)" value="1"></v-radio>
                            <v-radio :label="$t(`pos.saleTab['Bekreft valg']`)" value="2"></v-radio>
                            <v-radio :label="$t(`pos.saleTab['Automatisk sletting']`)" value="3"></v-radio>
                        </v-radio-group>
                    </v-col>
                    <v-col cols="3">
                        <v-container class="fill-height">
                            <div class="align-center font-italic">{{ $t(`pos.saleTab['Denne innstillingen bestemmer hvordan et blankt besøk skal håndteres i kassen']`) }}</div>
                        </v-container>
                    </v-col>
                </v-row>
                <v-btn color="success" class="mr-4"> {{ $t(`Lagre`) }}</v-btn>
                <v-btn color="error" class="mr-4"> {{ $t(`Avbryt`) }}</v-btn>
            </v-card>
        </v-form>
    </v-container>
</template>

<script>
   export default {
      data () {
         return {
            radioGroup: '1'
         }
      },
      name: 'pos-sale'
   }
</script>

<style scoped>

</style>
